function getExtendedConciergePdf(state) {
	if (state.isUsCa) {
		return 'https://go.ackuretta.com/us-ca-concierge/Downloads';
	} else if (state.isAuNz || state.isIndia) {
		return 'https://go.ackuretta.com/anz-india-concierge/Downloads';
	} else if (state.isLatam) {
		return 'https://go.ackuretta.com/latam-concierge/Downloads';
	} else if (state.isEurope) {
		return '	https://go.ackuretta.com/eur-concierge/Downloads';
	}

	return 'https://go.ackuretta.com/apac-concierge/Downloads';
}
